var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (boardDirectors) {pug_html = pug_html + "\u003Csection class=\"board-directors\"\u003E\u003Cdiv class=\"container text-center\"\u003E\u003Cdiv class=\"sub-title\"\u003EBoard of Directors\u003C\u002Fdiv\u003E\u003Cdiv class=\"board-directors__item-list\"\u003E";
// iterate boardDirectors
;(function(){
  var $$obj = boardDirectors;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var item = $$obj[pug_index0];
pug_html = pug_html + "\u003Carticle class=\"board-directors__item-list__item\"\u003E\u003Cimg" + (pug.attr("src", item.icon, true, true)+pug.attr("alt", item.name, true, true)) + "\u003E\u003Cdiv class=\"h4\"\u003E" + (pug.escape(null == (pug_interp = item.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cp class=\"title\"\u003E" + (pug.escape(null == (pug_interp = item.title) ? "" : pug_interp)) + " \u003Cbr\u003E\u003Cdiv class=\"sub-title\"\u003E" + (pug.escape(null == (pug_interp = item.category) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fp\u003E\u003C\u002Farticle\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var item = $$obj[pug_index0];
pug_html = pug_html + "\u003Carticle class=\"board-directors__item-list__item\"\u003E\u003Cimg" + (pug.attr("src", item.icon, true, true)+pug.attr("alt", item.name, true, true)) + "\u003E\u003Cdiv class=\"h4\"\u003E" + (pug.escape(null == (pug_interp = item.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cp class=\"title\"\u003E" + (pug.escape(null == (pug_interp = item.title) ? "" : pug_interp)) + " \u003Cbr\u003E\u003Cdiv class=\"sub-title\"\u003E" + (pug.escape(null == (pug_interp = item.category) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fp\u003E\u003C\u002Farticle\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";}.call(this,"boardDirectors" in locals_for_with?locals_for_with.boardDirectors:typeof boardDirectors!=="undefined"?boardDirectors:undefined));;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/partials/board-directors.pug
// module id = 1069
// module chunks = 0